import { registerQuery } from 'data-fetching-client';
import quickFetch from 'quick-fetch';
import { fetchAvailabilityPage, fetchV3PublicAvailabilityInfo } from '../api/bookingAPIV3';
const AVAILABILITY_PAGE_EARLY_REQUEST_NAME = 'availability-page';
export const fetchV3PublicAvailabilityInfoQuery = registerQuery({
  fieldName: 'publicAvailabilityInfo',
  args: ['slug', 'now'],
  fetcher: queryParams => fetchV3PublicAvailabilityInfo(queryParams)
});
export const fetchAvailabilityPageQuery = registerQuery({
  fieldName: 'publicAvailabilityPage',
  args: ['monthOffset', 'slug', 'timezone', 'email'],
  fetcher: queryParams => {
    if (queryParams.monthOffset === 0) {
      const earlyRequest = quickFetch.getRequestStateByName(AVAILABILITY_PAGE_EARLY_REQUEST_NAME);
      if (earlyRequest) {
        const earlyRequestTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (queryParams.timezone !== earlyRequestTimezone) {
          quickFetch.removeEarlyRequest(AVAILABILITY_PAGE_EARLY_REQUEST_NAME);
          return fetchAvailabilityPage(queryParams);
        }
        if (earlyRequest.finished && !earlyRequest.error) {
          quickFetch.removeEarlyRequest(AVAILABILITY_PAGE_EARLY_REQUEST_NAME);
          return Promise.resolve(earlyRequest.data);
        }
        return new Promise((resolve, reject) => {
          let settled = false;
          earlyRequest.whenFinished(response => {
            if (settled) return;
            settled = true;
            quickFetch.removeEarlyRequest(AVAILABILITY_PAGE_EARLY_REQUEST_NAME);
            resolve(response);
          });
          earlyRequest.onError(() => {
            if (settled) return;
            settled = true;
            quickFetch.removeEarlyRequest(AVAILABILITY_PAGE_EARLY_REQUEST_NAME);
            fetchAvailabilityPage(queryParams).then(resolve).catch(reject);
          });
        });
      }
    }
    return fetchAvailabilityPage(queryParams);
  }
});